import { createReducer } from 'redux-act';
import actions from '../actions/departmentAction';

const initialState = {
  addDepartmentPending: false,
  addDepartmentRes: null,
  addDepartmentError: null,

  getAllDepartmentPending: false,
  getAllDepartmentRes: null,
  getAllDepartmentError: null,

  getDepartmentListPending: false,
  getDepartmentListRes: null,
  getDepartmentListError: null,

  updateDepartmentPending: false,
  updateDepartmentRes: null,
  updateDepartmentError: null,

  deleteDepartmentPending: false,
  deleteDepartmentRes: null,
  deleteDepartmentError: null,

  createSubDepartmentPending: false,
  createSubDepartmentRes: null,
  createSubDepartmentError: null,

  getSubDepartmentPending: false,
  getSubDepartmentRes: null,
  getSubDepartmentError: null,

  updateSubDepartmentPending: false,
  updateSubDepartmentRes: null,
  updateSubDepartmentError: null,

  getAllSubDepartmentListPending: false,
  getAllSubDepartmentListRes: null,
  getAllSubDepartmentListError: null,

  getSubDepartmentByDepartmentRequest: false,
  getSubDepartmentByDepartmentSuccess: null,
  getSubDepartmentByDepartmentError: null,

  createProjectPending: false,
  createProjectRes: null,
  createProjectError: null,

  getProjectPending: false,
  getProjectRes: null,
  getProjectError: null,

  updateProjectPending: false,
  updateProjectRes: null,
  updateProjectError: null,

  getAllProjectListPending: false,
  getAllProjectListRes: null,
  getAllProjectListError: null,

  createSkillPending: false,
  createSkillRes: null,
  createSkillError: null,

  getSkillPending: false,
  getSkillRes: null,
  getSkillError: null,

  updateSkillPending: false,
  updateSkillRes: null,
  updateSkillError: null,

  getAllSkillListPending: false,
  getAllSkillListRes: null,
  getAllSkillListError: null,

  assignProjectPending: false,
  assignProjectRes: null,
  assignProjectError: null,

  getAssignProjectPending: false,
  getAssignProjectRes: null,
  getAssignProjectError: null,

  assignSkillPending: false,
  assignSkillRes: null,
  assignSkillError: null,

  getAssignSkillPending: false,
  getAssignSkillRes: null,
  getAssignSkillError: null,

  addProjectTypePending: false,
  addProjectTypeRes: null,
  addProjectTypeError: null,

  getProjectTypePending: false,
  getProjectTypeRes: null,
  getProjectTypeError: null,

  updateProjectTypePending: false,
  updateProjectTypeRes: null,
  updateProjectTypeError: null,

  deleteProjectTypePending: false,
  deleteProjectTypeRes: null,
  deleteProjectTypeError: null,

  getAllProjectTypeListPending: false,
  getAllProjectTypeListRes: null,
  getAllProjectTypeListError: null,


  addProjectCategoryPending: false,
  addProjectCategoryRes: null,
  addProjectCategoryError: null,

  getProjectCategoryPending: false,
  getProjectCategoryRes: null,
  getProjectCategoryError: null,

  updateProjectCategoryPending: false,
  updateProjectCategoryRes: null,
  updateProjectCategoryError: null,

  deleteProjectCategoryPending: false,
  deleteProjectCategoryRes: null,
  deleteProjectCategoryError: null,

  getAllProjectCategoryListPending: false,
  getAllProjectCategoryListRes: null,
  getAllProjectCategoryListError: null,


  getMastersCountsPending: false,
  getMastersCountsRes: null,
  getMastersCountsError: null,


};
/* Add Department Reducers */
const handleAddDepartmentRequest = state => {
  return {
    ...state,
    ...{
      addDepartmentPending: true,
      addDepartmentRes: null,
      addDepartmentError: null,
    },
  };
};
const handleAddDepartmentSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addDepartmentPending: false,
      addDepartmentRes: payload,
      addDepartmentError: null,
    },
  };
};
const handleAddDepartmentError = (state, payload) => ({
  ...state,
  ...{
    addDepartmentPending: false,
    addDepartmentRes: null,
    addDepartmentError: payload,
  },
});


/* Get All Department Reducers */
const handleGetAllDepartmentRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllDepartmentPending: true,
      getAllDepartmentRes: null,
      getAllDepartmentError: null,
    },
  };
};
const handleGetAllDepartmentSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllDepartmentPending: false,
      getAllDepartmentRes: payload,
      getAllDepartmentError: null,
    },
  };
};
const handleGetAllDepartmentError = (state1, payload) => ({
  ...state1,
  ...{
    getAllDepartmentPending: false,
    getAllDepartmentRes: null,
    getAllDepartmentError: payload,
  },
});

/* Get Department List Reducers */
const handleGetDepartmentListRequest = state1 => {
  return {
    ...state1,
    ...{
      getDepartmentListPending: true,
      getDepartmentListRes: null,
      getDepartmentListError: null,
    },
  };
};
const handleGetDepartmentListSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getDepartmentListPending: false,
      getDepartmentListRes: payload,
      getDepartmentListError: null,
    },
  };
};
const handleGetDepartmentListError = (state1, payload) => ({
  ...state1,
  ...{
    getDepartmentListPending: false,
    getDepartmentListRes: null,
    getDepartmentListError: payload,
  },
});

/* Update Department Reducers */
const handleUpdateDepartmentRequest = state1 => {
  return {
    ...state1,
    ...{
      updateDepartmentPending: true,
      updateDepartmentRes: null,
      updateDepartmentError: null,
    },
  };
};
const handleUpdateDepartmentSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateDepartmentPending: false,
      updateDepartmentRes: payload,
      updateDepartmentError: null,
    },
  };
};
const handleUpdateDepartmentError = (state1, payload) => ({
  ...state1,
  ...{
    updateDepartmentPending: false,
    updateDepartmentRes: null,
    updateDepartmentError: payload,
  },
});

/* Delete Department Reducers*/
const handleDeleteDepartmentRequest = state1 => {
  return {
    ...state1,
    ...{
      deleteDepartmentPending: true,
      deleteDepartmentRes: null,
      deleteDepartmentError: null,
    },
  };
};
const handleDeleteDepartmentSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      deleteDepartmentPending: false,
      deleteDepartmentRes: payload,
      deleteDepartmentError: null,
    },
  };
};
const handleDeleteDepartmentError = (state1, payload) => ({
  ...state1,
  ...{
    deleteDepartmentPending: false,
    deleteDepartmentRes: null,
    deleteDepartmentError: payload,
  },
});


/*  create Sub Department Reducers */
const handleCreateSubDepartmentRequest = state => {
  return {
    ...state,
    ...{
      createSubDepartmentPending: true,
      createSubDepartmentRes: null,
      createSubDepartmentError: null,
    },
  };
};
const handleCreateSubDepartmentSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      createSubDepartmentPending: false,
      createSubDepartmentRes: payload,
      createSubDepartmentError: null,
    },
  };
};
const handleCreateSubDepartmentError = (state, payload) => ({
  ...state,
  ...{
    createSubDepartmentPending: false,
    createSubDepartmentRes: null,
    createSubDepartmentError: payload,
  },
});

/* Get Sub Department Reducers */
const handleGetSubDepartmentRequest = state1 => {
  return {
    ...state1,
    ...{
      getSubDepartmentPending: true,
      getSubDepartmentRes: null,
      getSubDepartmentError: null,
    },
  };
};
const handleGetSubDepartmentSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getSubDepartmentPending: false,
      getSubDepartmentRes: payload,
      getSubDepartmentError: null,
    },
  };
};
const handleGetSubDepartmentError = (state1, payload) => ({
  ...state1,
  ...{
    getSubDepartmentPending: false,
    getSubDepartmentRes: null,
    getSubDepartmentError: payload,
  },
});

/* Get All Sub Department List Reducers */
const handleGetAllSubDepartmentListRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllSubDepartmentListPending: true,
      getAllSubDepartmentListRes: null,
      getAllSubDepartmentListError: null,
    },
  };
};
const handleGetAllSubDepartmentListSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllSubDepartmentListPending: false,
      getAllSubDepartmentListRes: payload,
      getAllSubDepartmentListError: null,
    },
  };
};
const handleGetAllSubDepartmentListError = (state1, payload) => ({
  ...state1,
  ...{
    getAllSubDepartmentListPending: false,
    getAllSubDepartmentListRes: null,
    getAllSubDepartmentListError: payload,
  },
});

/* Get Sub Department By Department Reducers */
const handleGetSubDepartmentByDepartmentRequest = state1 => {
  return {
    ...state1,
    ...{
      getSubDepartmentByDepartmentPending: true,
      getSubDepartmentByDepartmentRes: null,
      getSubDepartmentByDepartmentError: null,
    },
  };
};
const handleGetSubDepartmentByDepartmentSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getSubDepartmentByDepartmentPending: false,
      getSubDepartmentByDepartmentRes: payload,
      getSubDepartmentByDepartmentError: null,
    },
  };
};
const handleGetSubDepartmentByDepartmentError = (state1, payload) => ({
  ...state1,
  ...{
    getSubDepartmentByDepartmentPending: false,
    getSubDepartmentByDepartmentRes: null,
    getSubDepartmentByDepartmentError: payload,
  },
});

/* Update Department Reducers */
const handleUpdateSubDepartmentRequest = state1 => {
  return {
    ...state1,
    ...{
      updateSubDepartmentPending: true,
      updateSubDepartmentRes: null,
      updateSubDepartmentError: null,
    },
  };
};
const handleUpdateSubDepartmentSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateSubDepartmentPending: false,
      updateSubDepartmentRes: payload,
      updateSubDepartmentError: null,
    },
  };
};
const handleUpdateSubDepartmentError = (state1, payload) => ({
  ...state1,
  ...{
    updateSubDepartmentPending: false,
    updateSubDepartmentRes: null,
    updateSubDepartmentError: payload,
  },
});

/*  create Sub Project Reducers */
const handleCreateProjectRequest = state => {
  return {
    ...state,
    ...{
      createProjectPending: true,
      createProjectRes: null,
      createProjectError: null,
    },
  };
};
const handleCreateProjectSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      createProjectPending: false,
      createProjectRes: payload,
      createProjectError: null,
    },
  };
};
const handleCreateProjectError = (state, payload) => ({
  ...state,
  ...{
    createProjectPending: false,
    createProjectRes: null,
    createProjectError: payload,
  },
});

/* Get Sub Project Reducers */
const handleGetProjectRequest = state1 => {
  return {
    ...state1,
    ...{
      getProjectPending: true,
      getProjectRes: null,
      getProjectError: null,
    },
  };
};
const handleGetProjectSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getProjectPending: false,
      getProjectRes: payload,
      getProjectError: null,
    },
  };
};
const handleGetProjectError = (state1, payload) => ({
  ...state1,
  ...{
    getProjectPending: false,
    getProjectRes: null,
    getProjectError: payload,
  },
});

/* Get All Sub Project List Reducers */
const handleGetAllProjectListRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllProjectListPending: true,
      getAllProjectListRes: null,
      getAllProjectListError: null,
    },
  };
};
const handleGetAllProjectListSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllProjectListPending: false,
      getAllProjectListRes: payload,
      getAllProjectListError: null,
    },
  };
};
const handleGetAllProjectListError = (state1, payload) => ({
  ...state1,
  ...{
    getAllProjectListPending: false,
    getAllProjectListRes: null,
    getAllProjectListError: payload,
  },
});

/* Update Project Reducers */
const handleUpdateProjectRequest = state1 => {
  return {
    ...state1,
    ...{
      updateProjectPending: true,
      updateProjectRes: null,
      updateProjectError: null,
    },
  };
};
const handleUpdateProjectSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateProjectPending: false,
      updateProjectRes: payload,
      updateProjectError: null,
    },
  };
};
const handleUpdateProjectError = (state1, payload) => ({
  ...state1,
  ...{
    updateProjectPending: false,
    updateProjectRes: null,
    updateProjectError: payload,
  },
});

/*  create Sub Skill Reducers */
const handleCreateSkillRequest = state => {
  return {
    ...state,
    ...{
      createSkillPending: true,
      createSkillRes: null,
      createSkillError: null,
    },
  };
};
const handleCreateSkillSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      createSkillPending: false,
      createSkillRes: payload,
      createSkillError: null,
    },
  };
};
const handleCreateSkillError = (state, payload) => ({
  ...state,
  ...{
    createSkillPending: false,
    createSkillRes: null,
    createSkillError: payload,
  },
});

/* Get Sub Skill Reducers */
const handleGetSkillRequest = state1 => {
  return {
    ...state1,
    ...{
      getSkillPending: true,
      getSkillRes: null,
      getSkillError: null,
    },
  };
};
const handleGetSkillSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getSkillPending: false,
      getSkillRes: payload,
      getSkillError: null,
    },
  };
};
const handleGetSkillError = (state1, payload) => ({
  ...state1,
  ...{
    getSkillPending: false,
    getSkillRes: null,
    getSkillError: payload,
  },
});

/* Get All Sub Skill List Reducers */
const handleGetAllSkillListRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllSkillListPending: true,
      getAllSkillListRes: null,
      getAllSkillListError: null,
    },
  };
};
const handleGetAllSkillListSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllSkillListPending: false,
      getAllSkillListRes: payload,
      getAllSkillListError: null,
    },
  };
};
const handleGetAllSkillListError = (state1, payload) => ({
  ...state1,
  ...{
    getAllSkillListPending: false,
    getAllSkillListRes: null,
    getAllSkillListError: payload,
  },
});

/* Update Skill Reducers */
const handleUpdateSkillRequest = state1 => {
  return {
    ...state1,
    ...{
      updateSkillPending: true,
      updateSkillRes: null,
      updateSkillError: null,
    },
  };
};
const handleUpdateSkillSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateSkillPending: false,
      updateSkillRes: payload,
      updateSkillError: null,
    },
  };
};
const handleUpdateSkillError = (state1, payload) => ({
  ...state1,
  ...{
    updateSkillPending: false,
    updateSkillRes: null,
    updateSkillError: payload,
  },
});


/*  Assign Project Reducers */
const handleAssignProjectRequest = state => {
  return {
    ...state,
    ...{
      assignProjectPending: true,
      assignProjectRes: null,
      assignProjectError: null,
    },
  };
};
const handleAssignProjectSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      assignProjectPending: false,
      assignProjectRes: payload,
      assignProjectError: null,
    },
  };
};
const handleAssignProjectError = (state, payload) => ({
  ...state,
  ...{
    assignProjectPending: false,
    assignProjectRes: null,
    assignProjectError: payload,
  },
});

/* Get Assign ProjectReducers */
const handleGetAssignProjectRequest = state1 => {
  return {
    ...state1,
    ...{
      getAssignProjectPending: true,
      getAssignProjectRes: null,
      getAssignProjectError: null,
    },
  };
};
const handleGetAssignProjectSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAssignProjectPending: false,
      getAssignProjectRes: payload,
      getAssignProjectError: null,
    },
  };
};
const handleGetAssignProjectError = (state1, payload) => ({
  ...state1,
  ...{
    getAssignProjectPending: false,
    getAssignProjectRes: null,
    getAssignProjectError: payload,
  },
});

/* Assign Skill Reducers */
const handleAssignSkillRequest = state1 => {
  return {
    ...state1,
    ...{
      assignSkillPending: true,
      assignSkillRes: null,
      assignSkillError: null,
    },
  };
};
const handleAssignSkillSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      assignSkillPending: false,
      assignSkillRes: payload,
      assignSkillError: null,
    },
  };
};
const handleAssignSkillError = (state1, payload) => ({
  ...state1,
  ...{
    assignSkillPending: false,
    assignSkillRes: null,
    assignSkillError: payload,
  },
});

/* Get Assign Skill Reducers */
const handleGetAssignSkillRequest = state1 => {
  return {
    ...state1,
    ...{
      getAssignSkillPending: true,
      getAssignSkillRes: null,
      getAssignSkillError: null,
    },
  };
};
const handleGetAssignSkillSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAssignSkillPending: false,
      getAssignSkillRes: payload,
      getAssignSkillError: null,
    },
  };
};
const handleGetAssignSkillError = (state1, payload) => ({
  ...state1,
  ...{
    getAssignSkillPending: false,
    getAssignSkillRes: null,
    getAssignSkillError: payload,
  },
});


/* project type */


/*  create Sub Project Reducers */
const handleAddProjectTypeRequest = state => {
  return {
    ...state,
    ...{
      addProjectTypePending: true,
      addProjectTypeRes: null,
      addProjectTypeError: null,
    },
  };
};
const handleAddProjectTypeSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addProjectTypePending: false,
      addProjectTypeRes: payload,
      addProjectTypeError: null,
    },
  };
};
const handleAddProjectTypeError = (state, payload) => ({
  ...state,
  ...{
    addProjectTypePending: false,
    addProjectTypeRes: null,
    addProjectTypeError: payload,
  },
});

/* Get Sub Project Reducers */
const handleGetProjectTypeRequest = state1 => {
  return {
    ...state1,
    ...{
      getProjectTypePending: true,
      getProjectTypeRes: null,
      getProjectTypeError: null,
    },
  };
};
const handleGetProjectTypeSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getProjectTypePending: false,
      getProjectTypeRes: payload,
      getProjectTypeError: null,
    },
  };
};
const handleGetProjectTypeError = (state1, payload) => ({
  ...state1,
  ...{
    getProjectTypePending: false,
    getProjectTypeRes: null,
    getProjectTypeError: payload,
  },
});

/* Get All Sub Project List Reducers */
const handleGetAllProjectTypeListRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllProjectTypeListPending: true,
      getAllProjectTypeListRes: null,
      getAllProjectTypeListError: null,
    },
  };
};
const handleGetAllProjectTypeListSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllProjectTypeListPending: false,
      getAllProjectTypeListRes: payload,
      getAllProjectTypeListError: null,
    },
  };
};
const handleGetAllProjectTypeListError = (state1, payload) => ({
  ...state1,
  ...{
    getAllProjectTypeListPending: false,
    getAllProjectTypeListRes: null,
    getAllProjectTypeListError: payload,
  },
});

/* Update Project Reducers */
const handleUpdateProjectTypeRequest = state1 => {
  return {
    ...state1,
    ...{
      updateProjectTypePending: true,
      updateProjectTypeRes: null,
      updateProjectTypeError: null,
    },
  };
};
const handleUpdateProjectTypeSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateProjectTypePending: false,
      updateProjectTypeRes: payload,
      updateProjectTypeError: null,
    },
  };
};
const handleUpdateProjectTypeError = (state1, payload) => ({
  ...state1,
  ...{
    updateProjectTypePending: false,
    updateProjectTypeRes: null,
    updateProjectTypeError: payload,
  },
});


/* Delete Project Reducers */
const handleDeleteProjectTypeRequest = state1 => {
  return {
    ...state1,
    ...{
      deleteProjectTypePending: true,
      deleteProjectTypeRes: null,
      deleteProjectTypeError: null,
    },
  };
};
const handleDeleteProjectTypeSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      deleteProjectTypePending: false,
      deleteProjectTypeRes: payload,
      deleteProjectTypeError: null,
    },
  };
};
const handleDeleteProjectTypeError = (state1, payload) => ({
  ...state1,
  ...{
    deleteProjectTypePending: false,
    deleteProjectTypeRes: null,
    deleteProjectTypeError: payload,
  },
});

/*  create Sub Project Reducers */
const handleAddProjectCategoryRequest = state => {
  return {
    ...state,
    ...{
      addProjectCategoryPending: true,
      addProjectCategoryRes: null,
      addProjectCategoryError: null,
    },
  };
};
const handleAddProjectCategorySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addProjectCategoryPending: false,
      addProjectCategoryRes: payload,
      addProjectCategoryError: null,
    },
  };
};
const handleAddProjectCategoryError = (state, payload) => ({
  ...state,
  ...{
    addProjectCategoryPending: false,
    addProjectCategoryRes: null,
    addProjectCategoryError: payload,
  },
});

/* Get Sub Project Reducers */
const handleGetProjectCategoryRequest = state1 => {
  return {
    ...state1,
    ...{
      getProjectCategoryPending: true,
      getProjectCategoryRes: null,
      getProjectCategoryError: null,
    },
  };
};
const handleGetProjectCategorySuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getProjectCategoryPending: false,
      getProjectCategoryRes: payload,
      getProjectCategoryError: null,
    },
  };
};
const handleGetProjectCategoryError = (state1, payload) => ({
  ...state1,
  ...{
    getProjectCategoryPending: false,
    getProjectCategoryRes: null,
    getProjectCategoryError: payload,
  },
});

/* Get All Sub Project List Reducers */
const handleGetAllProjectCategoryListRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllProjectCategoryListPending: true,
      getAllProjectCategoryListRes: null,
      getAllProjectCategoryListError: null,
    },
  };
};
const handleGetAllProjectCategoryListSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllProjectCategoryListPending: false,
      getAllProjectCategoryListRes: payload,
      getAllProjectCategoryListError: null,
    },
  };
};
const handleGetAllProjectCategoryListError = (state1, payload) => ({
  ...state1,
  ...{
    getAllProjectCategoryListPending: false,
    getAllProjectCategoryListRes: null,
    getAllProjectCategoryListError: payload,
  },
});

/* Update Project Reducers */
const handleUpdateProjectCategoryRequest = state1 => {
  return {
    ...state1,
    ...{
      updateProjectCategoryPending: true,
      updateProjectCategoryRes: null,
      updateProjectCategoryError: null,
    },
  };
};
const handleUpdateProjectCategorySuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateProjectCategoryPending: false,
      updateProjectCategoryRes: payload,
      updateProjectCategoryError: null,
    },
  };
};
const handleUpdateProjectCategoryError = (state1, payload) => ({
  ...state1,
  ...{
    updateProjectCategoryPending: false,
    updateProjectCategoryRes: null,
    updateProjectCategoryError: payload,
  },
});

/* Delete Project Reducers */
const handleDeleteProjectCategoryRequest = state1 => {
  return {
    ...state1,
    ...{
      deleteProjectCategoryPending: true,
      deleteProjectCategoryRes: null,
      deleteProjectCategoryError: null,
    },
  };
};
const handleDeleteProjectCategorySuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      deleteProjectCategoryPending: false,
      deleteProjectCategoryRes: payload,
      deleteProjectCategoryError: null,
    },
  };
};
const handleDeleteProjectCategoryError = (state1, payload) => ({
  ...state1,
  ...{
    deleteProjectCategoryPending: false,
    deleteProjectCategoryRes: null,
    deleteProjectCategoryError: payload,
  },
});

/* Get Masters Counts Reducers */
const handleGetMastersCountsRequest = state1 => {
  return {
    ...state1,
    ...{
      getMastersCountsPending: true,
      getMastersCountsRes: null,
      getMastersCountsError: null,
    },
  };
};
const handleGetMastersCountsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getMastersCountsPending: false,
      getMastersCountsRes: payload,
      getMastersCountsError: null,
    },
  };
};
const handleGetMastersCountsError = (state1, payload) => ({
  ...state1,
  ...{
    getMastersCountsPending: false,
    getMastersCountsRes: null,
    getMastersCountsError: payload,
  },
});








// Clear Existing Data Store Reducers*/
const clearDepartmentStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_ADD_DEPARTMENT_STORE':
      return {
        ...state,
        ...{
          addDepartmentPending: false,
          addDepartmentRes: null,
          addDepartmentError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_DEPARTMENT_STORE':
      return {
        ...state,
        ...{
          updateDepartmentPending: false,
          updateDepartmentRes: null,
          updateDepartmentError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_DEPARTMENT_STORE':
      return {
        ...state,
        ...{
          deleteDepartmentPending: false,
          deleteDepartmentRes: null,
          deleteDepartmentError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_DEPARTMENT_LIST_STORE':
      return {
        ...state,
        ...{
          getDepartmentListPending: false,
          getDepartmentListRes: null,
          getDepartmentListError: null,
        },
      };
    case 'HANDLE_CLEAR_CREATE_SUB_DEPARTMENT_STORE':
      return {
        ...state,
        ...{
          createSubDepartmentPending: false,
          createSubDepartmentRes: null,
          createSubDepartmentError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_SUB_DEPARTMENT_STORE':
      return {
        ...state,
        ...{
          updateSubDepartmentPending: false,
          updateSubDepartmentRes: null,
          updateSubDepartmentError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_SUB_DEPARTMENT_STORE':
      return {
        ...state,
        ...{
          getSubDepartmentPending: false,
          getSubDepartmentRes: null,
          getSubDepartmentError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_ALL_SUB_DEPARTMENT_LIST_STORE':
      return {
        ...state,
        ...{
          getAllSubDepartmentListPending: false,
          getAllSubDepartmentListRes: null,
          getAllSubDepartmentListError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_SUB_DEPARTMENT_BY_DEPARTMENT_STORE':
      return {
        ...state,
        ...{
          getSubDepartmentByDepartmentPending: false,
          getSubDepartmentByDepartmentRes: null,
          getSubDepartmentByDepartmentError: null,
        },
      };
    case 'HANDLE_CLEAR_CREATE_PROJECT_STORE':
      return {
        ...state,
        ...{
          createProjectPending: false,
          createProjectRes: null,
          createProjectError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_PROJECT_STORE':
      return {
        ...state,
        ...{
          updateProjectPending: false,
          updateProjectRes: null,
          updateProjectError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_PROJECT_STORE':
      return {
        ...state,
        ...{
          getProjectPending: false,
          getProjectRes: null,
          getProjectError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_ALL_PROJECT_LIST_STORE':
      return {
        ...state,
        ...{
          getAllProjectListPending: false,
          getAllProjectListRes: null,
          getAllProjectListError: null,
        },
      };

    case 'HANDLE_CLEAR_CREATE_SKILL_STORE':
      return {
        ...state,
        ...{
          createSkillPending: false,
          createSkillRes: null,
          createSkillError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_SKILL_STORE':
      return {
        ...state,
        ...{
          updateSkillPending: false,
          updateSkillRes: null,
          updateSkillError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_SKILL_STORE':
      return {
        ...state,
        ...{
          getSkillPending: false,
          getSkillRes: null,
          getSkillError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_ALL_SKILL_LIST_STORE':
      return {
        ...state,
        ...{
          getAllSkillListPending: false,
          getAllSkillListRes: null,
          getAllSkillListError: null,
        },
      };

    case 'HANDLE_CLEAR_ASSIGN_PROJECT_STORE':
      return {
        ...state,
        ...{
          assignProjectPending: false,
          assignProjectRes: null,
          assignProjectError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_ASSIGN_PROJECT_STORE':
      return {
        ...state,
        ...{
          getAssignProjectPending: false,
          getAssignProjectRes: null,
          getAssignProjectError: null,
        },
      };
    case 'HANDLE_CLEAR_ASSIGN_SKILL_STORE':
      return {
        ...state,
        ...{
          assignSkillPending: false,
          assignSkillRes: null,
          assignSkillError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_ASSIGN_SKILL_STORE':
      return {
        ...state,
        ...{
          getAssignSkillPending: false,
          getAssignSkillRes: null,
          getAssignSkillError: null,
        },
      };
    case 'HANDLE_CLEAR_ADD_PROJECT_TYPE_STORE':
      return {
        ...state,
        ...{
          addProjectTypePending: false,
          addProjectTypeRes: null,
          addProjectTypeError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_PROJECT_TYPE_STORE':
      return {
        ...state,
        ...{
          updateProjectTypePending: false,
          updateProjectTypeRes: null,
          updateProjectTypeError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_PROJECT_TYPE_STORE':
      return {
        ...state,
        ...{
          deleteProjectTypePending: false,
          deleteProjectTypeRes: null,
          deleteProjectTypeError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_PROJECT_TYPE_STORE':
      return {
        ...state,
        ...{
          getProjectTypePending: false,
          getProjectTypeRes: null,
          getProjectTypeError: null,
        },
      };

    case 'HANDLE_CLEAR_GET_ALL_PROJECT_TYPE_LIST_STORE':
      return {
        ...state,
        ...{
          getAllProjectTypeListPending: false,
          getAllProjectTypeListRes: null,
          getAllProjectTypeListError: null,
        },
      };
    case 'HANDLE_CLEAR_ADD_PROJECT_CATEGORY_STORE':
      return {
        ...state,
        ...{
          addProjectCategoryPending: false,
          addProjectCategoryRes: null,
          addProjectCategoryError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_PROJECT_CATEGORY_STORE':
      return {
        ...state,
        ...{
          updateProjectCategoryPending: false,
          updateProjectCategoryRes: null,
          updateProjectCategoryError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_PROJECT_CATEGORY_STORE':
      return {
        ...state,
        ...{
          deleteProjectCategoryPending: false,
          deleteProjectCategoryRes: null,
          deleteProjectCategoryError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_PROJECT_CATEGORY_STORE':
      return {
        ...state,
        ...{
          getProjectCategoryPending: false,
          getProjectCategoryRes: null,
          getProjectCategoryError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_ALL_PROJECT_CATEGORY_LIST_STORE':
      return {
        ...state,
        ...{
          getAllProjectCategoryListPending: false,
          getAllProjectCategoryListRes: null,
          getAllProjectCategoryListError: null,
        },
      };

    default:
      return state;
  }
};



export default createReducer(
  {
    [actions.addDepartmentRequest]: handleAddDepartmentRequest,
    [actions.addDepartmentSuccess]: handleAddDepartmentSuccess,
    [actions.addDepartmentError]: handleAddDepartmentError,

    [actions.getAllDepartmentRequest]: handleGetAllDepartmentRequest,
    [actions.getAllDepartmentSuccess]: handleGetAllDepartmentSuccess,
    [actions.getAllDepartmentError]: handleGetAllDepartmentError,

    [actions.getDepartmentListRequest]: handleGetDepartmentListRequest,
    [actions.getDepartmentListSuccess]: handleGetDepartmentListSuccess,
    [actions.getDepartmentListError]: handleGetDepartmentListError,

    [actions.updateDepartmentRequest]: handleUpdateDepartmentRequest,
    [actions.updateDepartmentSuccess]: handleUpdateDepartmentSuccess,
    [actions.updateDepartmentError]: handleUpdateDepartmentError,

    [actions.deleteDepartmentRequest]: handleDeleteDepartmentRequest,
    [actions.deleteDepartmentSuccess]: handleDeleteDepartmentSuccess,
    [actions.deleteDepartmentError]: handleDeleteDepartmentError,

    [actions.createSubDepartmentRequest]: handleCreateSubDepartmentRequest,
    [actions.createSubDepartmentSuccess]: handleCreateSubDepartmentSuccess,
    [actions.createSubDepartmentError]: handleCreateSubDepartmentError,

    [actions.getSubDepartmentRequest]: handleGetSubDepartmentRequest,
    [actions.getSubDepartmentSuccess]: handleGetSubDepartmentSuccess,
    [actions.getSubDepartmentError]: handleGetSubDepartmentError,

    [actions.getAllSubDepartmentListRequest]: handleGetAllSubDepartmentListRequest,
    [actions.getAllSubDepartmentListSuccess]: handleGetAllSubDepartmentListSuccess,
    [actions.getAllSubDepartmentListError]: handleGetAllSubDepartmentListError,

    [actions.getSubDepartmentByDepartmentRequest]: handleGetSubDepartmentByDepartmentRequest,
    [actions.getSubDepartmentByDepartmentSuccess]: handleGetSubDepartmentByDepartmentSuccess,
    [actions.getSubDepartmentByDepartmentError]: handleGetSubDepartmentByDepartmentError,

    [actions.updateSubDepartmentRequest]: handleUpdateSubDepartmentRequest,
    [actions.updateSubDepartmentSuccess]: handleUpdateSubDepartmentSuccess,
    [actions.updateSubDepartmentError]: handleUpdateSubDepartmentError,

    [actions.createProjectRequest]: handleCreateProjectRequest,
    [actions.createProjectSuccess]: handleCreateProjectSuccess,
    [actions.createProjectError]: handleCreateProjectError,

    [actions.getProjectRequest]: handleGetProjectRequest,
    [actions.getProjectSuccess]: handleGetProjectSuccess,
    [actions.getProjectError]: handleGetProjectError,

    [actions.getAllProjectListRequest]: handleGetAllProjectListRequest,
    [actions.getAllProjectListSuccess]: handleGetAllProjectListSuccess,
    [actions.getAllProjectListError]: handleGetAllProjectListError,

    [actions.updateProjectRequest]: handleUpdateProjectRequest,
    [actions.updateProjectSuccess]: handleUpdateProjectSuccess,
    [actions.updateProjectError]: handleUpdateProjectError,

    [actions.createSkillRequest]: handleCreateSkillRequest,
    [actions.createSkillSuccess]: handleCreateSkillSuccess,
    [actions.createSkillError]: handleCreateSkillError,

    [actions.getSkillRequest]: handleGetSkillRequest,
    [actions.getSkillSuccess]: handleGetSkillSuccess,
    [actions.getSkillError]: handleGetSkillError,

    [actions.getAllSkillListRequest]: handleGetAllSkillListRequest,
    [actions.getAllSkillListSuccess]: handleGetAllSkillListSuccess,
    [actions.getAllSkillListError]: handleGetAllSkillListError,

    [actions.updateSkillRequest]: handleUpdateSkillRequest,
    [actions.updateSkillSuccess]: handleUpdateSkillSuccess,
    [actions.updateSkillError]: handleUpdateSkillError,

    [actions.assignProjectRequest]: handleAssignProjectRequest,
    [actions.assignProjectSuccess]: handleAssignProjectSuccess,
    [actions.assignProjectError]: handleAssignProjectError,

    [actions.getAssignProjectRequest]: handleGetAssignProjectRequest,
    [actions.getAssignProjectSuccess]: handleGetAssignProjectSuccess,
    [actions.getAssignProjectError]: handleGetAssignProjectError,

    [actions.assignSkillRequest]: handleAssignSkillRequest,
    [actions.assignSkillSuccess]: handleAssignSkillSuccess,
    [actions.assignSkillError]: handleAssignSkillError,

    [actions.getAssignSkillRequest]: handleGetAssignSkillRequest,
    [actions.getAssignSkillSuccess]: handleGetAssignSkillSuccess,
    [actions.getAssignSkillError]: handleGetAssignSkillError,

    [actions.addProjectTypeRequest]: handleAddProjectTypeRequest,
    [actions.addProjectTypeSuccess]: handleAddProjectTypeSuccess,
    [actions.addProjectTypeError]: handleAddProjectTypeError,

    [actions.getProjectTypeRequest]: handleGetProjectTypeRequest,
    [actions.getProjectTypeSuccess]: handleGetProjectTypeSuccess,
    [actions.getProjectTypeError]: handleGetProjectTypeError,

    [actions.getAllProjectTypeListRequest]: handleGetAllProjectTypeListRequest,
    [actions.getAllProjectTypeListSuccess]: handleGetAllProjectTypeListSuccess,
    [actions.getAllProjectTypeListError]: handleGetAllProjectTypeListError,

    [actions.updateProjectTypeRequest]: handleUpdateProjectTypeRequest,
    [actions.updateProjectTypeSuccess]: handleUpdateProjectTypeSuccess,
    [actions.updateProjectTypeError]: handleUpdateProjectTypeError,

    [actions.deleteProjectTypeRequest]: handleDeleteProjectTypeRequest,
    [actions.deleteProjectTypeSuccess]: handleDeleteProjectTypeSuccess,
    [actions.deleteProjectTypeError]: handleDeleteProjectTypeError,

    [actions.addProjectCategoryRequest]: handleAddProjectCategoryRequest,
    [actions.addProjectCategorySuccess]: handleAddProjectCategorySuccess,
    [actions.addProjectCategoryError]: handleAddProjectCategoryError,

    [actions.getProjectCategoryRequest]: handleGetProjectCategoryRequest,
    [actions.getProjectCategorySuccess]: handleGetProjectCategorySuccess,
    [actions.getProjectCategoryError]: handleGetProjectCategoryError,

    [actions.getAllProjectCategoryListRequest]: handleGetAllProjectCategoryListRequest,
    [actions.getAllProjectCategoryListSuccess]: handleGetAllProjectCategoryListSuccess,
    [actions.getAllProjectCategoryListError]: handleGetAllProjectCategoryListError,

    [actions.updateProjectCategoryRequest]: handleUpdateProjectCategoryRequest,
    [actions.updateProjectCategorySuccess]: handleUpdateProjectCategorySuccess,
    [actions.updateProjectCategoryError]: handleUpdateProjectCategoryError,

    [actions.deleteProjectCategoryRequest]: handleDeleteProjectCategoryRequest,
    [actions.deleteProjectCategorySuccess]: handleDeleteProjectCategorySuccess,
    [actions.deleteProjectCategoryError]: handleDeleteProjectCategoryError,

    [actions.getMastersCountsRequest]: handleGetMastersCountsRequest,
    [actions.getMastersCountsSuccess]: handleGetMastersCountsSuccess,
    [actions.getMastersCountsError]: handleGetMastersCountsError,

    [actions.handleClearDepartmentStore]: clearDepartmentStore,
  },
  initialState,
);